class StorageService {
	reservedKeys = {
		INBOX_INSTANCE_ID: "inbox-instance-id"
	}

	set<ExpectedData> (key: string, data: ExpectedData): void {
		const stringData = JSON.stringify(data)

		const encodedData = btoa(stringData)

		localStorage.setItem(key, encodedData)
	}

	get<ExpectedData> (key: string): ExpectedData | null {
		const encodedData = localStorage.getItem(key)

		if (!encodedData) {
			return null
		}

		const stringData = atob(encodedData)

		const data: ExpectedData = JSON.parse(stringData)

		return data
	}

	delete (key: string): void {
		localStorage.removeItem(key)
	}
}

export default new StorageService()
